import { render } from "./section-filter-client.vue?vue&type=template&id=442794c2&scoped=true&ts=true"
import script from "./section-filter-client.vue?vue&type=script&lang=ts"
export * from "./section-filter-client.vue?vue&type=script&lang=ts"

import "./section-filter-client.vue?vue&type=style&index=0&id=442794c2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-442794c2"]])

export default __exports__